const nonEditableWidgets = ['groupIntroduction', 'pageTitle']

export default function (type) {
    return !nonEditableWidgets.includes(type)
}
